import { Expose, Transform, Type } from 'class-transformer';

export enum NotificationTargetTypeEnum {
  /** Herkese göster (tüm kullanıcılar) */
  EVERYONE = 'EVERYONE',
  /** Belirli kullanıcılara göster */
  SPECIFIC_USERS = 'SPECIFIC_USERS',
  /** Belirli firmalara göster */
  SPECIFIC_COMPANIES = 'SPECIFIC_COMPANIES',
  /** Tüm firmalara göster */
  ALL_COMPANIES = 'ALL_COMPANIES',
  /** Belirli bayilere göster */
  SPECIFIC_VENDORS = 'SPECIFIC_VENDORS',
  /** Tüm bayilere göster */
  ALL_VENDORS = 'ALL_VENDORS',
  /** Belirli bir firmanın tüm bayilerine göster */
  COMPANY_ALL_VENDORS = 'COMPANY_ALL_VENDORS',
  /** Belirli bölgelere göster */
  SPECIFIC_REGIONS = 'SPECIFIC_REGIONS',
  /** Tüm bölgelere göster */
  ALL_REGIONS = 'ALL_REGIONS',
  /** Belirli şehirlere göster */
  SPECIFIC_CITIES = 'SPECIFIC_CITIES',
  /** Belirli alt şehirlere (ilçe) göster */
  SPECIFIC_SUBCITIES = 'SPECIFIC_SUBCITIES',
  /** Operasyon kullanıcılarına göster (company_id = 1) */
  OPERATION_USERS = 'OPERATION_USERS',
  /** Firma kullanıcılarına göster (company_id > 1, vendor_n = 0) */
  COMPANY_USERS = 'COMPANY_USERS',
  /** Bayi kullanıcılarına göster (vendor_n > 0) */
  VENDOR_USERS = 'VENDOR_USERS',
  /** Özel kombinasyon (birden fazla hedef tipi) */
  CUSTOM_COMBINATION = 'CUSTOM_COMBINATION'
}

export type TargetType = `${NotificationTargetTypeEnum}`;

export class PanelNotification {
  @Expose()
  @Transform(({ value }) => (value?.toString ? value.toString() : value))
  _id!: string;

  @Expose()
  title!: string;

  @Expose()
  description!: string;

  @Expose()
  @Type(() => Date)
  display_start_date!: Date;

  @Expose()
  @Type(() => Date)
  display_end_date!: Date;

  @Expose()
  created_by!: number;

  @Expose()
  creator_name!: string;

  @Expose()
  is_active!: boolean;

  @Expose()
  priority?: number;

  @Expose()
  urls?: string[];

  @Expose()
  target_type?: TargetType;

  @Expose()
  target_user_ids?: number[];

  @Expose()
  target_company_ids?: number[];

  @Expose()
  target_vendor_ids?: number[];

  @Expose()
  target_region_ids?: number[];

  @Expose()
  target_city_ids?: number[];

  @Expose()
  target_subcity_ids?: number[];

  @Expose()
  exclude_user_ids?: number[];

  @Expose()
  exclude_company_ids?: number[];

  @Expose()
  exclude_vendor_ids?: number[];

  @Expose()
  include_operation_users?: boolean;

  @Expose()
  include_company_users?: boolean;

  @Expose()
  include_vendor_users?: boolean;

  @Expose()
  is_read?: boolean;

  @Expose()
  @Type(() => Date)
  createdAt!: Date;

  @Expose()
  @Type(() => Date)
  updatedAt!: Date;
}

export class IPanelNotificationResponse {
  @Expose()
  @Type(() => PanelNotification)
  result!: PanelNotification;
}

export class IPanelNotificationListResponse {
  @Expose()
  @Type(() => PanelNotification)
  results!: PanelNotification[];

  @Expose()
  page!: number;

  @Expose()
  limit!: number;

  @Expose()
  total!: number;
}

export interface IPanelNotificationQueryDto {
  page?: number;
  limit?: number;
  sort_field?: string;
  sort_order?: 'asc' | 'desc';
  title?: string;
  is_active?: boolean;
  created_by?: number;
  active_at?: string;
}

export interface CreatePanelNotificationDto {
  title: string;
  description: string;
  display_start_date: string;
  display_end_date: string;
  priority?: number;
  urls?: string[];
  target_type?: TargetType;
  target_user_ids?: number[];
  target_company_ids?: number[];
  target_vendor_ids?: number[];
  target_region_ids?: number[];
  target_city_ids?: number[];
  target_subcity_ids?: number[];
  exclude_user_ids?: number[];
  exclude_company_ids?: number[];
  exclude_vendor_ids?: number[];
  include_operation_users?: boolean;
  include_company_users?: boolean;
  include_vendor_users?: boolean;
}

export interface UpdatePanelNotificationDto {
  title?: string;
  description?: string;
  display_start_date?: string;
  display_end_date?: string;
  priority?: number;
  urls?: string[];
  target_type?: TargetType;
  target_user_ids?: number[];
  target_company_ids?: number[];
  target_vendor_ids?: number[];
  target_region_ids?: number[];
  target_city_ids?: number[];
  target_subcity_ids?: number[];
  exclude_user_ids?: number[];
  exclude_company_ids?: number[];
  exclude_vendor_ids?: number[];
  include_operation_users?: boolean;
  include_company_users?: boolean;
  include_vendor_users?: boolean;
}
